import { PublicBaseEventSerializer } from "@app-contexts/public/features/event-detail/data/types/events";
import {
  PublicInternalAnalyticsTrackingSerializer,
  PublicInternalAnalyticsTrackingSerializerWithLabelString,
} from "@shared/modules/analytics/types";
import { IBasket } from "@shared/modules/basket/interfaces/IBasket";
import { ContentViewItem } from "@shared/lib/analytics/types/analytics-types";

export interface IHasAnalyticsParams {
  id?: number;
  ga_tracking_id?: string | null;
  ga_4_tracking_id?: string | null;
  aw_global_tag?: string | null;
  google_tag_manager_id?: string | null;
  org_facebook_pixel?: string | null;
}

export interface IHasTicketTypes {
  ticket_types?: PublicBaseEventSerializer["ticket_types"];
}

export interface IHasName {
  name: string;
}

export interface AnalyticsPageViewOptions {
  routeUrl?: string;
  // allow because <event|product|membership>.headers.uuid is unknown
  uuid?: string | unknown;
}

export type BeginCheckoutParams = {
  basket: IBasket;
  stepId?: string;
  triggerExternal?: boolean;
  forceGuestCheckout?: boolean;
  hasGuestCheckout?: boolean;
  customParams?: Record<string, unknown>;
};

export type AnalyticsPageViewData = Omit<
  PublicInternalAnalyticsTrackingSerializer,
  "interaction_type"
>;

export type AnalyticsViewContentData = AnalyticsPageViewData & {
  item?: ContentViewItem;
};

export type AnalyticsButtonClickData = Omit<
  PublicInternalAnalyticsTrackingSerializerWithLabelString,
  "interaction_type"
>;

export enum EventTypes {
  PageView = "PAGE_VIEW",
  ButtonClick = "BUTTON_CLICK",
  CartUpdated = "CART_UPDATED",
  ViewContent = "VIEW_CONTENT",
  ViewItems = "VIEW_ITEMS",
  BeginCheckout = "BEGIN_CHECKOUT",
  PostPurchase = "POST_PURCHASE",
  AwConversion = "AW_CONVERSION",
  VenueInit = "VENUE_INIT",
  AddToCart = "ADD_TO_CART",
  RemoveFromCart = "REMOVE_FROM_CART",
  TrackToken = "TRACK_TOKEN",
  GrantConsent = "GRANT_CONSENT",
  RevokeConsent = "REVOKE_CONSENT",
  DisableVenue = "DISABLE_VENUE",
  Initialized = "INITIALIZED",
  Track = "TRACK",
}
